import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Container } from "reactstrap";
import classnames from "classnames";
import { UserContext } from "../utils";
// Imported DIRECTLY, not through the components barrel: this file lives in layouts and most components
// import DesktopContainer, so pulling in components/index.js here would create a module cycle.
import ActiveAccountPicker from "../components/ActiveAccountPicker";
import _ from 'lodash';

export default function DesktopContainer(props) {
  const userCtx = useContext(UserContext);
  const currentUser = userCtx && userCtx.currentUser ? userCtx.currentUser : null;
  const [displayContainer , setDisplayContainer] = useState("");

  useEffect(() => {
    // eslint-disable-next-line no-mixed-operators
    if(userCtx.currentUser && _.includes(window.location.pathname, "mobile") || userCtx.currentUser && !userCtx.pinnedState) {
      setDisplayContainer("desktopContainer");
    } else if(userCtx.currentUser) {
      setDisplayContainer("desktopContainerPinned");
    }    
  }, [userCtx])

  return (
    <Container fluid className={classnames({
      "desktopContainerPublic": !currentUser,
      [displayContainer] : currentUser
    }, "")}>
      <Row className="m-0 p-0 fullHeight" >
        <Col className="m-0">
          <Row className="m-0 px-1">
            <Col className="text-center my-2 p-0">
              {props.screenName && (<h3 className="primaryDarkText">{props.screenName}</h3>)}
              {/* App-wide active-account control for customer users - renders null for everyone else, so
                  this is inert for the 144 screens that wrap DesktopContainer with an internal audience. */}
              <ActiveAccountPicker />
            </Col>
          </Row>
          <Row className="m-0 p-0 fullHeight">
            <Col className="m-0 p-0">
              {props.children}
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}
